export default __webpack_public_path__ + "static/media/my-notes.34ae8c14.png";